export default function DetailSection({ title, items }) {
  return (
    <div className="bg-white border rounded-lg shadow p-6 mb-6">
      <h2 className="text-xl font-semibold mb-4">{title}</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8">
        {items.map((item, idx) => (
          <div
            key={idx}
            className="flex justify-between border-b py-2 text-sm"
          >
            <span className="text-gray-600">{item.label}</span>
            <span className="font-medium">{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
